<template>
  <div class="flex flex-col w-full p-24 overflow-hidden">
    <div class="w-full">
      <div class="rounded-lg bg-[#e5e5e5] w-[150px] h-[20px] sm-vertical-spacing" />
      <div class="rounded-lg bg-[#e5e5e5] w-11/12 h-[110px] sm-vertical-spacing" />
    </div>
    <div class="rounded-lg bg-[#e5e5e5] w-3/5 h-[20px] sm-vertical-spacing" />
    <div class="rounded-lg bg-[#e5e5e5] w-2/5 h-[20px] sm-vertical-spacing" />
    <ul class="flex flex-row overflow-hidden gap-12 w-full justify-items-start">
      <div class="rounded-lg bg-[#e5e5e5] mr-1 w-1/4 h-[163px] sm-vertical-spacing" />
      <div class="rounded-lg bg-[#e5e5e5] mr-1 w-1/4 h-[163px] sm-vertical-spacing" />
      <div class="rounded-lg bg-[#e5e5e5] mr-1 w-1/4 h-[163px] sm-vertical-spacing" />
      <div class="rounded-lg bg-[#e5e5e5] mr-1 w-1/4 h-[163px] sm-vertical-spacing" />
    </ul>
    <div class="w-full">
      <div class="rounded-lg bg-[#e5e5e5] w-[150px] h-[20px] sm-vertical-spacing" />
      <div class="rounded-lg bg-[#e5e5e5] w-11/12 h-[110px] sm-vertical-spacing" />
      <div class="rounded-lg bg-[#e5e5e5] w-3/5 h-[20px] sm-vertical-spacing" />
      <div class="rounded-lg bg-[#e5e5e5] w-2/5 h-[20px] sm-vertical-spacing" />
    </div>
  </div>
</template>

<script lang="ts">
export default {
  name: 'ShowApplicationsSkeleton',
};
</script>
